const constants = {
  set: 'TYPES_SET',
};

const set = (types) => ({
  type: constants.set,
  payload: types,
});

const typesActions = {
  constants,
  set,
};

export default typesActions;
